import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { initializePushFailed, pushInitSuccess } from './push-notifications.actions';

export interface PushState {
  pushSupported: boolean;
  pushEnabled: boolean;
}

export const pushNotificationReducer = _pushReducerFactory(window);

// visible for testing
export function _pushReducerFactory(_window) {
  return createReducer<PushState>(
    {
      pushSupported: 'Notification' in _window,
      pushEnabled: 'Notification' in _window && _window.Notification.permission === 'granted',
    },
    on(pushInitSuccess, (state, action) => ({
      ...state,
      pushSupported: true,
      pushEnabled: true,
    })),
    on(initializePushFailed, (state, action) => ({
      ...state,
      pushEnabled: false,
    }))
  );
}

export const _pushFeatureSelector = createFeatureSelector<PushState>('pushNotifications');
export const isPushSupported = createSelector(
  _pushFeatureSelector,
  (state) => state?.pushSupported
);
export const isPushEnabled = createSelector(_pushFeatureSelector, (state) => state?.pushEnabled);
